export const VERIFIED_DISABLED_FIELDS = [
  'ref_arrangement_stage_desc', // Status (columnId 3924)
  'arrangement_complete_date', // Close Date
  'ref_sale_condition_type_desc', // Tenure
  'net_rentable_area', // Net Rentable Area
  'ref_net_rentable_area_uom_desc', // Net Rentable Area UOM
  'passing_rent_amount_yearly', // Passing Rent Amount Yearly
  'passing_rent_amount_yearly_uom', // Passing Rent Amount Yearly UOM
  'vacant_estimated_rental_amount', // Vacant Estimated Rental Amount
  'vacant_estimated_rental_amount_uom', // Vacant Estimated Rental Amount UOM
  'potential_gross_income', // Potential Gross Income
  'potential_gross_income_uom', // Potential Gross Income UOM
  'wavg_unexpired_lease_term', // WAVG Unexpired Lease Term
  'ref_wavg_unexpired_lease_term_uom_desc', // WAVG Unexpired Lease Term UOM
  'wavg_unexpired_term_certain', // WAVG Unexpired Term Certain
  'buyer_cost', //Purchasers Costs
  'buyer_cost_uom_desc', //Purchasers Costs UOM
  'gross_investment_amount', //Gross Investment
  'gross_investment_amount_uom', //Gross Investment UOM
  'actual_sales_price', // Actual Sales Price
  'ref_actual_sales_price_yearly_uom_desc', // Actual Sales Price Yearly UOM
  'sales_price_per_square_foot', //Price per SQM
  'ref_sales_price_per_square_foot_uom_desc', //Price per SQM Uom
  'arrangement_yield_detail/yield_type_desc', // Yield Type
  'operating_expenses', // Operating Expenses
  'operating_expenses_uom', // Operating Expenses UOM
  'net_operating_income', // Net Operating Income
  'ref_net_operating_income_uom_desc', // Net Operating Income UOM
  'arrangement_yield_detail/yield_percent', // Yield Percent
  'vacant_possession_value_amount', // Vacant Possession Value Amount
  'vacant_possession_value_amount_uom', // Vacant Possession Value Amount UOM
  'vacant_possession_value_rate', // Vacant Possession Value Rate
  'vacant_possession_value_rate_uom', // Vacant Possession Value Rate UOM
  'vacant_possession_value_ratio', // Vacant Possession Value Ratio
  'local_authority_value_amount', //Property Value per Local Tax Law (WOZ value)
  'local_authority_value_amount_uom', //Property Value per Local Tax Law (WOZ value) UOM
  'property.number_parking_space', // Number of Parking Spaces
  'property.property_usage.total_number_of_unit', // Total Number of Units
];

export enum vasApprovalFlag {
  verified = 'Verified',
  rejected = 'Rejected',
  toBeVerified = 'To Be Verified',
}
